import { alpha, Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import ContentLoader from '../../subcomponents/ContentLoader';
import AdminSettingBool from '../inputs/AdminSettingBool';
import AdminSettingNumber from '../inputs/AdminSettingNumber';
import AdminSettingText from '../inputs/AdminSettingText';

export default function SiomSettingsTab() {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { siomSettings, siomSettingsStatus } = useSelector((state) => state.settings.siom);

    return (
        <ContentLoader
            successCondition={siomSettingsStatus === "success"}
            errorCondition={siomSettingsStatus === "failed"}
            content={
                <Box sx={{ width: 1 }}>
                    <Grid container spacing={1}>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* VOORTGANG */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.SIOM_TITLE_PROGRESS}</Typography>
                            </Grid>
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_GroeneVlaggenVoortgang"}
                                settingDefaultValue={siomSettings?.flagProgress}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_FLAG_PROGRESS}
                                formText={resourceFinal[appLanguage].admin.SIOM_FLAG_PROGRESS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Gradual_Points"}
                                settingDefaultValue={siomSettings?.gradualPoints}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_GRAD_POINTS}
                                formText={resourceFinal[appLanguage].admin.SIOM_GRAD_POINTS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_RemoveAbsentSubscribedPoints"}
                                settingDefaultValue={siomSettings?.removeAbsentSubscribedPoints}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_REMOVE_ABSENT_SUBSCRIBED_POINTS}
                                formText={resourceFinal[appLanguage].admin.SIOM_REMOVE_ABSENT_SUBSCRIBED_POINTS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EnableRequiredPrograms"}
                                settingDefaultValue={siomSettings?.enableRequiredPrograms}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ENABLE_REQUIRED_PROGRAMS}
                                formText={resourceFinal[appLanguage].admin.SIOM_ENABLE_REQUIRED_PROGRAMS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EnableMainSubPrograms"}
                                settingDefaultValue={siomSettings?.enableMainSubPrograms}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ENABLE_MAINSUB_PROGRAMS}
                                formText={resourceFinal[appLanguage].admin.SIOM_ENABLE_MAINSUB_PROGRAMS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={12}
                            />
                        </Grid>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.secondary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* INSCHRIJVEN */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.SIOM_TITLE_REGISTER}</Typography>
                            </Grid>
                            <AdminSettingNumber
                                settingsType={"siom"}
                                settingKey={"Siom_MomentDefaultDuration"}
                                settingDefaultValue={siomSettings?.momentDefaultDuration}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_MOMENT_DEFAULT_DURATION}
                                formText={resourceFinal[appLanguage].admin.SIOM_MOMENT_DEFAULT_DURATION_HTEXT}
                                xsSize={6}
                                minValue={0}
                                stepValue={0.25}
                                notEmpty
                            />
                            <AdminSettingNumber
                                settingsType={"siom"}
                                settingKey={"Siom_DefaultTimeAfterActivityInMinutes"}
                                settingDefaultValue={siomSettings?.defaultTimeAfterActivityInMinutes}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_MOMENT_DEFAULT_TIME_AFTER}
                                formText={resourceFinal[appLanguage].admin.SIOM_MOMENT_DEFAULT_TIME_AFTER_HTEXT}
                                xsSize={6}
                                minValue={0}
                                stepValue={0.25}
                                notEmpty
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_IsReservation"}
                                settingDefaultValue={siomSettings?.isReservation}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_RESERVATION}
                                formText={resourceFinal[appLanguage].admin.SIOM_RESERVATION_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_ShowSearchRegisterTab"}
                                settingDefaultValue={siomSettings?.showSearchRegisterTab}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_SHOW_REGISTER_TAB}
                                formText={resourceFinal[appLanguage].admin.SIOM_SHOW_REGISTER_TAB_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingNumber
                                settingsType={"siom"}
                                settingKey={"Siom_Uitschrijfperiode"}
                                settingDefaultValue={siomSettings?.unsubscribePeriod}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_UNSUBSCRIBE_PERIOD}
                                formText={resourceFinal[appLanguage].admin.SIOM_UNSUBSCRIBE_PERIOD_HTEXT}
                                xsSize={6}
                                minValue={0}
                                notEmpty
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EnableSubscriptionOutsideProgramma"}
                                settingDefaultValue={siomSettings?.enableSubscriptionOutsideProgram}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ENABLE_SUBSCRIPTION_OUTSIDE_PROGRAM}
                                formText={resourceFinal[appLanguage].admin.SIOM_ENABLE_SUBSCRIPTION_OUTSIDE_PROGRAM_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EnableSubscriptionOutsideSchedule"}
                                settingDefaultValue={siomSettings?.enableSubscriptionOutsideSchedule}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ENABLE_SUBSCRIPTION_OUTSIDE_SCHEDULE}
                                formText={resourceFinal[appLanguage].admin.SIOM_ENABLE_SUBSCRIPTION_OUTSIDE_SCHEDULE_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EnableAbsenceBlock"}
                                settingDefaultValue={siomSettings?.enableAbsenceBlock}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ENABLE_ABSENCE_BLOCK}
                                formText={resourceFinal[appLanguage].admin.SIOM_ENABLE_ABSENCE_BLOCK_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EnableUnsubscribeDays"}
                                settingDefaultValue={siomSettings?.enableUnsubscribeDays}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ENABLE_UNSUBSCRIBE_DAYS}
                                formText={resourceFinal[appLanguage].admin.SIOM_ENABLE_UNSUBSCRIBE_DAYS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingNumber
                                settingsType={"siom"}
                                settingKey={"Siom_DefaultUnsubscribeDays"}
                                settingDefaultValue={siomSettings?.defaultUnsubscribeDays}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_DEFAULT_UNSUBSCRIBE_DAYS}
                                formText={resourceFinal[appLanguage].admin.SIOM_DEFAULT_UNSUBSCRIBE_DAYS_HTEXT}
                                xsSize={6}
                                minValue={0}
                            />
                        </Grid>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* PLANNEN */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.SIOM_TITLE_PLANNING}</Typography>
                            </Grid>
                            <AdminSettingNumber
                                settingsType={"siom"}
                                settingKey={"SIOM_SUBSCRIPTIONSTARTDAYSFORPERIOD"}
                                settingDefaultValue={siomSettings?.subscriptionStartDaysForPeriod}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_SUBSCRIBE_DEFAULT_DAYS_BEFORE_PERIOD}
                                formText={resourceFinal[appLanguage].admin.SIOM_SUBSCRIBE_DEFAULT_DAYS_BEFORE_PERIOD_HTEXT}
                                xsSize={6}
                                minValue={0}
                                notEmpty
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"SIOM_SUBSCRIPTIONDEFAULTSTARTTIME"}
                                settingDefaultValue={siomSettings?.subscriptionDefaultStartTime}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_SUBSCRIBE_DEFAULT_STARTTIME}
                                formText={resourceFinal[appLanguage].admin.SIOM_SUBSCRIBE_DEFAULT_STARTTIME_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"Siom_SubscriptionDefaultEndTime"}
                                settingDefaultValue={siomSettings?.subscriptionDefaultEndTime}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_SUBSCRIBE_DEFAULT_ENDTIME}
                                formText={resourceFinal[appLanguage].admin.SIOM_SUBSCRIBE_DEFAULT_ENDTIME_HTEXT}
                                xsSize={12}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EnablePerformanceName"}
                                settingDefaultValue={siomSettings?.enablePerformanceName}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ENABLE_PERFORMANCE_NAME}
                                formText={resourceFinal[appLanguage].admin.SIOM_ENABLE_PERFORMANCE_NAME_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"Siom_Moment_DefaultAmount"}
                                settingDefaultValue={siomSettings?.momentDefaultAmount}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_MOMENT_DEFAULT_AMOUNT}
                                formText={resourceFinal[appLanguage].admin.SIOM_MOMENT_DEFAULT_AMOUNT_HTEXT}
                                xsSize={6}
                            />
                        </Grid>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.secondary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* DEPARTMENT */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.SIOM_TITLE_DEPARTMENT}</Typography>
                            </Grid>
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_UseMultipleDepartments"}
                                settingDefaultValue={siomSettings?.useMultipleDepartments}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_DEPARTMENTS}
                                formText={resourceFinal[appLanguage].admin.SIOM_DEPARTMENTS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_EmployeeShowAllDepartments"}
                                settingDefaultValue={siomSettings?.employeeShowAllDepartments}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_SHOW_ALL_DEPARTMENTS}
                                formText={resourceFinal[appLanguage].admin.SIOM_SHOW_ALL_DEPARTMENTS_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                        </Grid>
                        <Grid container spacing={1} size={{ xs: 12 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                            {/* OTHER */}
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="button">{resourceFinal[appLanguage].admin.SIOM_TITLE_OTHER}</Typography>
                            </Grid>
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_Mentor_As_Contact"}
                                settingDefaultValue={siomSettings?.mentorAsContact}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_MENTOR_CONTACT}
                                formText={resourceFinal[appLanguage].admin.SIOM_MENTOR_CONTACT_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                            <AdminSettingNumber
                                settingsType={"siom"}
                                settingKey={"Siom_TravelCost_Hours_Limit"}
                                settingDefaultValue={siomSettings?.travelCostHoursLimit}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_TRAVEL_COST}
                                formText={resourceFinal[appLanguage].admin.SIOM_TRAVEL_COST_HTEXT}
                                xsSize={6}
                                minValue={1}
                            />
                            <AdminSettingText
                                settingsType={"siom"}
                                settingKey={"Siom_DefaultAttendanceSort"}
                                settingDefaultValue={siomSettings?.defaultAttendanceSort}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ATTENDANCE_SORT}
                                formText={resourceFinal[appLanguage].admin.SIOM_ATTENDANCE_SORT_HTEXT}
                                xsSize={6}
                            />
                            <AdminSettingBool
                                settingsType={"siom"}
                                settingKey={"Siom_AlternateSchoolclassOverview"}
                                settingDefaultValue={siomSettings?.alternateSchoolclassOverview}
                                formLabel={resourceFinal[appLanguage].admin.SIOM_ALTERNATE_SCHOOLCLASS_OVERVIEW}
                                formText={resourceFinal[appLanguage].admin.SIOM_ALTERNATE_SCHOOLCLASS_OVERVIEW_HTEXT}
                                controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                xsSize={6}
                            />
                        </Grid>
                    </Grid>
                </Box>
            }
        />
    );
} 